// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuArrow_button__1Z0Gy"};